import { render, staticRenderFns } from "./cssTab.vue?vue&type=template&id=28b67058&"
import script from "./cssTab.vue?vue&type=script&lang=js&"
export * from "./cssTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports